var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoYt = function SvgIcoYt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "m7.179 0 1.21.001.497.006c5.995.09 7.042.97 7.11 5.464L16 6l-.004.535c-.072 4.667-1.203 5.431-7.847 5.465h-.97l-.709-.009C.992 11.891.046 10.96.001 6.37L0 5.812l.004-.377C.077.827 1.156.037 7.179 0m-.57 3.882v4.236L10.085 6 6.608 3.882z"
  })));
};
export default SvgIcoYt;